import { Pipe, PipeTransform } from '@angular/core';
import { ColumnTypes } from '@features/navigation/desktop/main-menu/main-menu-config';
import { ColumnMenuViewModel } from '@models/api.models';

@Pipe({
    name: 'sortByColumn',
    standalone: true
})
export class SortByColumn implements PipeTransform {
    public transform(lists: ColumnMenuViewModel[]): ColumnMenuViewModel[] {
        return lists.sort(a => (a.contentTypeAlias === ColumnTypes.LeftColumn ? -1 : 1));
    }
}
